import $ from 'jquery';
import Cookies from 'js-cookie';
const ANALYTICS_PAGE_VIEW = 'analyticsPageview';

// We need jQuery for Analytics and some other microsites functionalities
window.$ = $;
window.jQuery = $;

// Old tags are looking for $.cookie
window.$.cookie = Cookies;

export default class Analytics {
  constructor() {
    this.sendPageview = this.sendPageview.bind(this);
    this.sendCustomEvent = this.sendCustomEvent.bind(this);
  }

  sendCustomEvent(eventName, eventDetail) {
    let activityEvent = new CustomEvent(eventName, { detail: eventDetail });
    document.body.dispatchEvent(activityEvent);
  }

  /* the second argument will be used to update the data layer, still working out the details for this, ideally team would pass the values they expect and in this function before sending the event we will update the data layer for each team. this will send a page view event for analytics, only use if instructed to do so by the analytics team. */
  sendPageview(TYPE) {
    this.sendCustomEvent(TYPE);
  }
}

const analyticsEvents = new Analytics();
const { sendPageview: sendAnalyticsPageview } = analyticsEvents;
export { sendAnalyticsPageview, ANALYTICS_PAGE_VIEW };
